// @ts-nocheck
import { Alert, Box, IconButton, Link } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import React, { memo, useState } from 'react';
import { METHODS_API } from '../../../api/api';
import { cadastreReportHistoryRequest, cadastreReportTechnologiesImportRequest } from '../../../api/cadastreApi';
import XLSXform6Example from '../../../assets/files/KO_template_import_transport.xlsx';
import { getActualVolumesHelper } from '../../../helpers/cadastreForms/form6Helper';
import { useApi } from '../../../hooks';
import { useDeleteCadastreEntity } from '../../../hooks/cadastre/useDeleteCadastreEntity';
import { precisionAdd } from '../../../helpers/numberHelper';
import useCadastreTabs from '../../../hooks/useCadastreTabs';
import CustomButton from '../../Buttons/CustomButton';
import CadastreForm6ActualVolume from '../../Cadastr/CadastreForm6ActualVolume';
import DropZone from '../../File/DropZone';
import ModalAddSubject from '../ModalAddSubject';
import ModalWithTitle from '../ModalWithTitle';
import BackdropLoading from '../../BackdropLoading';
import { TextTitle } from '../../Text';

function ModalCadastrForm6({
  data: { actualVolumes },
  changeItemFormByField,
  onChange,
  isDemo,
  deleteForm6Entity,
  report,
}) {
  const [createSubjectInfo, setCreateSubjectInfo] = useState(null);
  const [openedImport, setOpenedImport] = useState(false);
  const [transportedWasteTab, setTransportedWasteTab] = useState(null);
  const [importErrors, setImportErrors] = useState([]);

  const openImportModal = () => setOpenedImport(true);
  const closeImportModal = () => setOpenedImport(false);

  const { tab } = useCadastreTabs({ items: actualVolumes, tabName: 'Фактический объём' });

  const closeNewSubjectModal = () => setCreateSubjectInfo(null);

  const setNewSubject = (newSubject) => {
    onChange({
      field: `actualVolumes.${createSubjectInfo.index}.${createSubjectInfo.fieldName}`,
      value: { ...newSubject, ...newSubject?.attributes },
      reportActualVolumeIndex: createSubjectInfo.index,
    });
    closeNewSubjectModal();
  };

  const { openDeleteModal } = useDeleteCadastreEntity();


  const getFiles = async (dropZoneFiles) => {
    const formData = new FormData();

    formData.append('import[file]', dropZoneFiles[0]);
    formData.append('import[format_type]', 'xlsx');
    formData.append('import[kind]', 'report_actual_volumes');

    const importResponse = await cadastreReportTechnologiesImportRequest({
      method: METHODS_API.POST,
      data: formData,
      rest: `?report_history_id=${report.id}`,
      isFormData: true,
    });

    const errors = importResponse?.logs?.errors || [];
    if (errors.length > 0) {
      setImportErrors(errors);
    } else {
      setImportErrors([]);
    }

    const newReport = await cadastreReportHistoryRequest({
      method: METHODS_API.GET,
      id: report.id,
    });

    const createdActualVolumes = await getActualVolumesHelper(newReport);

    changeItemFormByField({
      field: 'form6', value: createdActualVolumes, type: 'import',
    });

    closeImportModal();
  };

  const { defaultRequest: importFromFile, isLoading: loadingImport } = useApi({ request: getFiles });

  const actualVolumeObj = (actualVolumes.find((el, i, arr) => {
    if (el.randId == tab) { return true; }
    return false;
  }));

  const totalVolume = actualVolumeObj?.transportedWastes.reduce((sum, waste) => {
    return precisionAdd(sum, waste.actual_volume_transported_waste || 0);
  }, 0);

  const actualTransportedWaste = actualVolumeObj?.transportedWastes.find(
    (waste) => waste.randId === transportedWasteTab
  );
  const sameLegalEntityWastes = actualVolumeObj?.transportedWastes.filter(
    (waste) =>
      waste.accept_subject_id.id ===
      actualTransportedWaste?.accept_subject_id.id
  );
  const totalAmount = sameLegalEntityWastes?.reduce((sum, waste) => {
    return precisionAdd(sum, waste.actual_volume_transported_waste || 0);
  }, 0);

  const acceptedLegalEntity = actualTransportedWaste?.accept_subject_id.name;

  return (
    <Box display="flex" flexDirection="column" gap={3}>
      {importErrors.length > 0 && (
        <Alert
          severity="error"
          sx={{
            bgcolor: "#d32f2f",
            color: "#fff",
            '& .MuiAlert-icon': {
              color: "#fff",
            }
          }}
          action={
            <IconButton
              size="small"
              aria-label="close"
              color="inherit"
              onClick={() => setImportErrors([])}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          }
        >
          <Box
            display="flex"
            flexDirection="column"
            gap={1}
            sx={{ marginLeft: "20px" }}
          >
            {importErrors.map((error, index) => (
              <span key={index}>{error}</span>
            ))}
          </Box>
        </Alert>
      )}
      <Box>
        <TextTitle h3>
          Итого по всем:
          {' '}
          {totalVolume}
        </TextTitle>
        <TextTitle h4>
          Итого по
          {' '}
          {acceptedLegalEntity}
          :
          {' '}
          {totalAmount}
        </TextTitle>
      </Box>
      <BackdropLoading position="fixed" isLoading={loadingImport} />
      {!isDemo && <CustomButton onClick={openImportModal}>Импортировать из файла</CustomButton>}
      {createSubjectInfo !== null && (
        <ModalAddSubject
          division="internal"
          close={closeNewSubjectModal}
          setNewSubject={setNewSubject}
        />
      )}
      {openedImport && (
        <ModalWithTitle open close={closeImportModal} title="Импортировать из файла">
          <Alert severity="warning" sx={{ mb: 2 }}>
            Загруженный файл должен быть формате Office Excel до 20 Мб, содержать не более 1000 строк. В файле должны содержаться наименование (ФИО), ИНН и транспортируемые отходы.
            <Link sx={{ ml: 1 }} href={XLSXform6Example}>Скачать пример файла импорта</Link>
          </Alert>
          <DropZone sx={{ height: 120 }} getFiles={(e, files) => importFromFile(files)} maxFiles={1} />
        </ModalWithTitle>
      )}
      {actualVolumes.map((actualVolume, actualVolumeIndex) => {
        if (actualVolume.randId !== tab) return null;

        return (
          <CadastreForm6ActualVolume
            deleteForm6Entity={deleteForm6Entity}
            setCreateSubjectInfo={setCreateSubjectInfo}
            key={actualVolume.randId}
            openDeleteModal={openDeleteModal}
            actualVolume={actualVolume}
            actualVolumes={actualVolumes}
            onChange={onChange}
            isDemo={isDemo}
            changeItemFormByField={changeItemFormByField}
            actualVolumeIndex={actualVolumeIndex}
            setTransportedWasteTab={setTransportedWasteTab}
          />
        );
      })}
    </Box>
  );
}

export default memo(ModalCadastrForm6);
